import styled, {css} from "styled-components";
import { IBannerContainerBoxProps } from "../../cms-banner/banner-container/banner-container.default.box";

export const HomepageTopBannerBackgroundBox = styled.div<IBannerContainerBoxProps>`
    width: 100%;
    position: absolute;
    background-image: url("${props => props.theme.images.homepageTopBannerPlaceholder.toString()}");
    ${props => props.minHeight && css`
        min-height: calc(${props.minHeight} + 1px);
    `};
`;
